import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type {
  IPostGeneratePaystubFileBody,
  IPostGeneratePaystubFileResponse,
} from "./postGeneratePaystubFile.schema";

export const postGeneratePaystubFile = (axios: IAxiosInstance) => {
  return async (
    requestBody: IPostGeneratePaystubFileBody,
    signal?: AbortSignal
  ) => {
    const response = await axios.noRetry.post<Blob>(
      "/reports/create/paystub",
      requestBody,
      {
        signal,
        responseType: "blob",
      }
    );

    // Check content-type header to determine response type
    const contentType =
      response.headers["content-type"] || response.headers["Content-Type"];

    // Canadian paystub - PDF blob streamed directly
    if (contentType?.includes("application/pdf")) {
      if (response.data instanceof Blob) {
        // Create object URL from blob and return it
        const url = window.URL.createObjectURL(response.data);
        return url;
      }
    }

    // US paystub - JSON response, parse the blob as text then JSON
    if (contentType?.includes("application/json")) {
      const text = await response.data.text();
      const jsonData = JSON.parse(text) as IPostGeneratePaystubFileResponse;

      if (jsonData.success) {
        return jsonData.data;
      }
    }

    throw new Error("Something went wrong");
  };
};
